import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Button } from "./Button";
import { Modal } from "./Modal";

export const DeleteModal = ({
  title,
  warningText,
  isOpen,
  onClose,
  handleConfirmDelete,
  error = "",
  loading = false,
}: {
  title: string;
  warningText: string;
  isOpen: boolean;
  onClose: () => void;
  handleConfirmDelete: () => void;
  error?: string;
  loading?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} maxWidth="md">
      <div className="space-y-4 py-4">
        <div className="flex items-center gap-4 p-4 bg-red-50 rounded-lg">
          <FontAwesomeIcon
            icon="exclamation-triangle"
            className="h-6 w-6 text-red-600"
          />
          <div>
            <h3 className="text-lg font-oxaniumMedium text-red-600 mb-1">
              {t("warning")}
            </h3>
            <p className="text-tertiary">{warningText}</p>
          </div>
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <div className="flex justify-end gap-4 pt-4 border-t border-grey-light">
          <Button type="button" variant="secondary" onClick={onClose}>
            {t("button-cancel")}
          </Button>
          <Button
            type="button"
            className="!bg-red-600 hover:!bg-red-700 !text-white"
            onClick={handleConfirmDelete}
            disabled={loading}
          >
            {t("delete")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
